import Auth from "./auth-oidc";

/**
 * INSPIRATION :
 * https://stackoverflow.com/questions/20969835/angularjs-login-and-authentication-in-each-route-and-controller
 *
 * */

const modul = angular.module("authenticationModule", []).service("Auth", Auth);

export default modul.name;
